export const getCollectorById = (collectorId, listCollector) => {
  const collector = listCollector.find(item => item.id === collectorId);

  return collector || undefined;
};

export const cleanDays = data => {
  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  return data.map(item => {
    days.forEach(day => {
      // Kiểm tra nếu day có tồn tại và loại bỏ các giá trị bằng 0
      if (item[day] && Array.isArray(item[day])) {
        item[day] = item[day].filter(value => value !== 0);
      }
    });
    return item;
  });
};

export const groupRouteHaveSameInfomation = data => {
  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const groupedMap = new Map();

  data.forEach(item => {
    // Tạo dữ liệu ngày bằng cách sắp xếp các mảng của từng ngày
    const daysData = JSON.stringify(
      days.reduce((acc, day) => {
        acc[day] = (item[day] || []).slice().sort((a, b) => a - b); // Sắp xếp mảng theo thứ tự tăng dần
        return acc;
      }, {})
    );

    // Tạo key để group theo `hub_id`, `route.id`, `timeSlot.id`, và `daysData`
    const key = `${item.hub_id}-${item.route.id}-${item.timeSlot.id}-${daysData}`;

    if (!groupedMap.has(key)) {
      groupedMap.set(key, {
        hub: {
          id: item.hub.id,
          name: item.hub.name,
          is_center: item?.hub?.is_center,
        },
        route: [
          {
            id: item.route.id,
            name: item.route.name,
          },
        ],
        // Trả ra object timeSlot với id và name
        timeSlot: {
          id: item.timeSlot.id,
          name: item.timeSlot.name,
        },
        // Giữ lại thông tin các ngày trong object
        days: JSON.parse(daysData),
      });
    } else {
      const existingGroup = groupedMap.get(key);
      // Kiểm tra và thêm route vào nếu chưa tồn tại
      if (!existingGroup.route.some(route => route.id === item.route.id)) {
        existingGroup.route.push({
          id: item.route.id,
          name: item.route.name,
        });
      }
    }
  });

  // Chuyển Map thành mảng và giữ lại dữ liệu ngày
  return Array.from(groupedMap.values()).map(group => ({
    hub: group.hub, // Trả lại object hub
    route: group.route,
    timeSlot: group.timeSlot, // Trả lại object timeSlot trong kết quả
    days: group.days,
  }));
};
